import { ServicePageTemplate } from "@/components/ServicePageTemplate";

export default function Geschaeftsaufloesung() {
  return (
    <ServicePageTemplate
      service={{
        title: "Geschäftsauflösung",
        keyword: "Geschäftsauflösung Berlin",
        metaTitle: "Geschäftsauflösung Berlin | Zuverlässig & Diskret | MIROS",
        metaDesc:
          "Schnelle und zuverlässige Geschäftsauflösung in Berlin. Ladenlokale, Lager und Werkstätten besenrein geräumt.",
        heroSub:
          "Strukturierte Räumung von Ladenlokalen, Lagern und Werkstätten zum Wunschtermin.",
        heroImg:
          "https://assets.cdn.filesafe.space/RcAk4NqqJiBX4hgBLewG/media/6a3a90165ff04dbbc3c00b0e.jpg",
        trustImg:
          "https://assets.cdn.filesafe.space/RcAk4NqqJiBX4hgBLewG/media/6a3a901a181eb301d4357a32.jpg",
        seoImg:
          "https://assets.cdn.filesafe.space/RcAk4NqqJiBX4hgBLewG/media/6a3a900eb2e956bc24f8c799.jpg",
        faqImg:
          "https://assets.cdn.filesafe.space/RcAk4NqqJiBX4hgBLewG/media/6a3a901a109a1ab49dc13ffb.jpg",
        trustIntro:
          "Die Auflösung eines Geschäftsbetriebs ist ein komplexes Projekt. Egal ob Einzelhandel, Gastronomie oder Handwerksbetrieb – wir räumen Ihre Gewerbeflächen termingerecht leer. So können Sie das Kapitel sauber abschließen und sich auf neue Aufgaben konzentrieren.",
        slug: "geschaeftsaufloesung-berlin",
      }}
    />
  );
}
